var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgKwenta = function SvgKwenta(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .214 0 5.93v5.714l10-5.714V.214Z",
    fill: "url(#paint0_linear_1081_5079)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.786 0 13.07V7.357l10 5.715v5.714Z",
    fill: "url(#paint1_linear_1081_5079)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 .214 20 5.93v5.714L10 5.929V.214Z",
    fill: "url(#paint2_linear_1081_5079)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10 18.786 10-5.715V7.357l-10 5.715v5.714Z",
    fill: "url(#paint3_linear_1081_5079)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1081_5079",
    x1: 10.062,
    y1: 2.557,
    x2: 0.665,
    y2: 10.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1081_5079",
    x1: 5,
    y1: 18.786,
    x2: 5,
    y2: 7.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1081_5079",
    x1: 28.527,
    y1: 5.897,
    x2: 3.868,
    y2: 5.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1081_5079",
    x1: 15,
    y1: 18.786,
    x2: 17.198,
    y2: -3.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B"
  })))));
};
export default SvgKwenta;